import React, { Component } from "react";

export default class ErrorAlert extends Component {
  render() {
    return (
      <div class="alert alert-danger alert-dismissible">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-hidden="true"
        >
          &times;
        </button>
        <h4>
          <i class="icon fa fa-ban"></i>
          {this.props.message}
        </h4>
      </div>
      // </div></div></section></div>
    );
  }
}
